export const SLICE_DURATION_VALUES = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0.5, 0.25]
